// extracted by mini-css-extract-plugin
export var bxTextTruncateEnd = "AnchorLinks-module--bx--text-truncate--end--Yy-I8";
export var bxTextTruncateFront = "AnchorLinks-module--bx--text-truncate--front--T7XLM";
export var link = "AnchorLinks-module--link--2M9fp";
export var list = "AnchorLinks-module--list--3VNwY";
export var listSmall = "AnchorLinks-module--list--small--2gJIv";
export var multipleColumns = "AnchorLinks-module--multiple-columns--3KP6o";